import React from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import moment from "moment";

import {
  ReviewContainer,
  ReviewHeaderWrapper,
  ReviewDate,
  ReviewBody,
  ReviewAuthor,
  ReviewInfo
} from './styles';

const Review = ({rating, name, description, checkInDate}) => (
  <ReviewContainer>
    <ReviewHeaderWrapper>
      <ReviewInfo>
        <StarRatings rating={rating || 5} numberOfStars={5} starRatedColor="#1eb6ff" starEmptyColor="#b6e4f9" starDimension="15px" starSpacing="0px" />
        <ReviewAuthor>by {name}</ReviewAuthor>
      </ReviewInfo>
      <ReviewDate>{moment(checkInDate).format('ddd, MMM DD YYYY')}</ReviewDate>
    </ReviewHeaderWrapper>
    {description && <ReviewBody>{description}</ReviewBody>}
  </ReviewContainer>
);

Review.propTypes = {
  rating: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  checkInDate: PropTypes.string,
};

export default Review;
